import Overlay from "../../../Componentes/Overlay";
import SidebarMenu from "../../../Componentes/SideMenu";
import SideMenuBtn from "../../../Componentes/SideMenuBtn";
import { useModal } from "../../../contexts/ModalContext";

const SidebarFaturamentoDireto = () => {

    const { closeModal, openModal } = useModal();

    const handleAdicionarPC = () => {

        closeModal();
        openModal("modalAdicionarPCFaturamentoDireto");

    };

    return (
        <Overlay state={true} changeContent={closeModal}>
            <SidebarMenu>
                <SideMenuBtn
                    button="ADICIONAR PC"
                    clickFunc={handleAdicionarPC}
                />
            </SidebarMenu>
        </Overlay>
    );

};

export default SidebarFaturamentoDireto;
